"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var t = require("io-ts");
var PathReporter_1 = require("io-ts/lib/PathReporter");
var React = require("react");
// tslint:disable-next-line no-empty
var noop = function () { };
function getExcessProps(values, props) {
    var excess = [];
    for (var k in values) {
        if (k !== 'children' && !props.hasOwnProperty(k)) {
            excess.push(k);
        }
    }
    return excess;
}
function getProps(values, type) {
    switch (type._tag) {
        case 'AnyType':
            return null;
        case 'RefinementType':
        case 'ReadonlyType':
            return getProps(values, type.type);
        case 'IntersectionType':
            var props_1 = type.types.map(function (type) { return getProps(values, type); }).filter(Boolean);
            if (props_1.length) {
                return Object.assign.apply(null, [{}].concat(props_1));
            }
            else {
                return null;
            }
        case 'InterfaceType':
        case 'PartialType':
        case 'StrictType':
            return type.props;
        case 'UnionType':
            for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
                var member = _a[_i];
                if (member.is(values)) {
                    return getProps(values, member);
                }
            }
            return null;
    }
}
function getPropTypes(type, options) {
    if (options === void 0) { options = { strict: true }; }
    return {
        __prop_types_ts: function (values, prop, displayName) {
            var validation = type.decode(values).chain(function (v) {
                if (options.children) {
                    return options.children.validate(values.children, [{ key: 'children', type: options.children }]);
                }
                else {
                    return t.success(v);
                }
            });
            return validation.fold(function () { return new Error('\n' + PathReporter_1.PathReporter.report(validation).join('\n')); }, function () {
                var props = options.strict ? getProps(values, type) : null;
                if (props) {
                    var excess = getExcessProps(values, props);
                    if (excess.length > 0) {
                        return new Error("\nInvalid additional prop(s): " + JSON.stringify(excess));
                    }
                }
                return null;
            });
        }
    };
}
exports.getPropTypes = getPropTypes;
var NODE_ENV = process.env.NODE_ENV;
function props(type, options) {
    if (NODE_ENV !== 'production') {
        var propsTypes_1 = getPropTypes(type, options);
        return function (Component) {
            Component.propTypes = propsTypes_1;
        };
    }
    return noop;
}
exports.props = props;
var ReactElementType = /** @class */ (function (_super) {
    __extends(ReactElementType, _super);
    function ReactElementType() {
        var _this = _super.call(this, 'ReactElement', React.isValidElement, function (m, c) { return t.object.validate(m, c).chain(function (o) { return (React.isValidElement(o) ? t.success(o) : t.failure(o, c)); }); }, t.identity) || this;
        _this._tag = 'ReactElement';
        return _this;
    }
    return ReactElementType;
}(t.Type));
exports.ReactElementType = ReactElementType;
exports.ReactElement = new ReactElementType();
var ReactChildType = /** @class */ (function (_super) {
    __extends(ReactChildType, _super);
    function ReactChildType() {
        var _this = _super.call(this, 'ReactChild', function (m) { return t.string.is(m) || t.number.is(m) || exports.ReactElement.is(m); }, function (m, c) { return (_this.is(m) ? t.success(m) : t.failure(m, c)); }, t.identity) || this;
        _this._tag = 'ReactChild';
        return _this;
    }
    return ReactChildType;
}(t.Type));
exports.ReactChildType = ReactChildType;
exports.ReactChild = new ReactChildType();
var ReactFragmentType = /** @class */ (function (_super) {
    __extends(ReactFragmentType, _super);
    function ReactFragmentType() {
        var _this = _super.call(this, 'ReactFragment', function (m) { return t.Dictionary.is(m) || ReactNodes.is(m); }, function (m, c) { return (_this.is(m) ? t.success(m) : t.failure(m, c)); }, t.identity) || this;
        _this._tag = 'ReactFragment';
        return _this;
    }
    return ReactFragmentType;
}(t.Type));
exports.ReactFragmentType = ReactFragmentType;
exports.ReactFragment = new ReactFragmentType();
var ReactNodeType = /** @class */ (function (_super) {
    __extends(ReactNodeType, _super);
    function ReactNodeType() {
        var _this = _super.call(this, 'ReactNode', function (m) {
            return t.boolean.is(m) || t.null.is(m) || t.undefined.is(m) || exports.ReactChild.is(m) || exports.ReactFragment.is(m);
        }, function (m, c) { return (_this.is(m) ? t.success(m) : t.failure(m, c)); }, t.identity) || this;
        _this._tag = 'ReactNode';
        return _this;
    }
    return ReactNodeType;
}(t.Type));
exports.ReactNodeType = ReactNodeType;
exports.ReactNode = new ReactNodeType();
var ReactNodes = t.array(exports.ReactNode);
//# sourceMappingURL=index.js.map